<template>
    <fragment>
        <c-hero-full has-bg-color invert-color class="illustration-section-01" />
        <c-features-split invert-mobile top-divider image-fill />
        <c-features-tiles/>
        <!-- <c-pricing has-bg-color pricing-switcher /> -->
        <!-- <c-testimonial /> -->
        <faqs />
        <ContactForm/>
        <c-cta has-bg-color invert-color split class="has-bg-color-cut" />
    </fragment>
</template>

<script>
// import layout
import CLayout from '@/layouts/LayoutDefault.vue'
// import sections
import CHeroFull from '@/components/sections/HeroFull.vue'
import CFeaturesTiles from '@/components/sections/FeaturesTiles.vue'
import CFeaturesSplit from '@/components/sections/FeaturesSplit.vue'
// import CPricing from '@/components/sections/Pricing.vue'
// import CTestimonial from '@/components/sections/Testimonial.vue'
import CCta from '@/components/sections/Cta.vue'
import Faqs from '@/components/sections/partials/Faqs.vue'
//import { VueMailchimpEmailSignupForm } from "vue-mailchimp-email-signup-form";
//import "vue-mailchimp-email-signup-form/dist/vue-mailchimp-email-signup-form.css";
import ContactForm from '@/components/sections/ContactForm.vue'

import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate)


export default {
  name: 'Home',
  components: {
    CHeroFull,
    CFeaturesTiles,
    CFeaturesSplit,
    // CPricing,
    // CTestimonial,
    CCta,
    Faqs,
    ContactForm,
    // VueMailchimpEmailSignupForm
  },
  created() {
    this.$emit('update:layout', CLayout)
  }
}
</script>
